module.exports = __webpack_public_path__ + "media/images/web_suite/dashboard/ebooks_icon-2867a592cf028531e5de37ecdfcf862a.png";